import { useEffect, useState } from 'react';
import { BreadcrumbItem } from './BreadcrumbsContext';

let setBreadcrumbsInternal: ((items: BreadcrumbItem[]) => void) | null = null;
let pushBreadcrumbInternal: ((item: BreadcrumbItem) => void) | null = null;
let popBreadcrumbInternal: (() => void) | null = null;
let clearBreadcrumbsInternal: (() => void) | null = null;
let versionListener: (() => void) | null = null;

export const BreadcrumbsManager = {
  breadcrumbs: [] as BreadcrumbItem[],

  init(
    push: (item: BreadcrumbItem) => void,
    pop: () => void,
    clear: () => void,
    set: (items: BreadcrumbItem[]) => void,
  ) {
    pushBreadcrumbInternal = push;
    popBreadcrumbInternal = pop;
    clearBreadcrumbsInternal = clear;
    setBreadcrumbsInternal = set;
  },

  initVersionListener(listener: () => void) {
    versionListener = listener;
  },

  _notifyChange() {
    if (versionListener) {
      versionListener();
    }
  },

  push(item: BreadcrumbItem) {
    if (pushBreadcrumbInternal) {
      pushBreadcrumbInternal(item);
    } else {
      this.breadcrumbs.push(item);
    }
    this._notifyChange();
  },

  pop() {
    if (popBreadcrumbInternal) {
      popBreadcrumbInternal();
    } else {
      this.breadcrumbs.pop();
    }
    this._notifyChange();
  },

  clear() {
    if (clearBreadcrumbsInternal) {
      clearBreadcrumbsInternal();
    } else {
      this.breadcrumbs = [];
    }
    this._notifyChange();
  },

  set(items: BreadcrumbItem[]) {
    if (setBreadcrumbsInternal) {
      setBreadcrumbsInternal(items);
    } else {
      this.breadcrumbs = [...items];
    }
    this._notifyChange();
  },

  peek(): BreadcrumbItem | undefined {
    return this.breadcrumbs[this.breadcrumbs.length - 1];
  },
};

export function useBreadcrumbs() {
  const [, setVersion] = useState(0);

  useEffect(() => {
    BreadcrumbsManager.initVersionListener(() => {
      setVersion((v) => v + 1); // Force re-render on breadcrumb change
    });
  }, []);

  return BreadcrumbsManager.breadcrumbs;
}
